import React from 'react';
interface SectionProps {
  id?: string;
  tone?: 'ink' | 'surface';
  className?: string;
  children: React.ReactNode;
}
export function Section({
  id,
  tone = 'ink',
  className = '',
  children
}: SectionProps) {
  const bg = tone === 'ink' ? 'bg-ink' : 'bg-surface';
  return <section id={id} className={`relative w-full ${bg} py-20 md:py-28 ${className}`} data-id="element-292" data-mp="2r62kg69zefjc">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-293" data-mp="2r47yqpqvyje7">{children}</div>
    </section>;
}